// @ts-check
// Faixa no topo da área autenticada: aviso da assinatura (teste acabando, atraso, cancelada), somente leitura e
// acesso do suporte. Some quando o acesso é completo e não há suporte.
import { html } from 'htm/preact';
import { sessionState } from '../../data/metadata-store.js';
import { Link } from '../../app/router.js';
import { Icon } from '../../ui/icon.js';
import { signOutAndRedirect } from '../auth/session.js';
import { formatDate } from '../../lib/format.js';
import { t } from '../../i18n/index.js';

/** @typedef {import('../../data/operations.js').SubscriptionState} SubscriptionState */

/** @param {SubscriptionState} state */
function warningText(state) {
  if (state.accessMode === 'READ_ONLY') return t('operations.banner.readOnly');
  if (state.reason === 'TRIAL_ENDING') return t('operations.banner.TRIAL_ENDING', { count: state.trialDaysLeft ?? 0 });
  if (state.reason) return t(`operations.banner.${state.reason}`, { date: formatDate(state.readOnlyAt) });
  return null;
}

export function SubscriptionBanner() {
  const session = /** @type {any} */ (sessionState.value);
  if (!session) return null;
  /** @type {SubscriptionState | undefined} */
  const state = session.subscription;
  const supportAccess = session.supportAccess;
  const text = state && state.accessMode !== 'FULL' ? warningText(state) : null;
  if (!text && !supportAccess) return null;
  return html`<div class="operations-banners">
    ${supportAccess
      ? html`<div class="operations-banner" data-variant="support" role="status">
          <${Icon} name="IconHeadset" size=${16} />
          <span class="operations-banner-text">${t('operations.banner.support', { email: supportAccess.email })}</span>
          <button type="button" class="operations-banner-action" onClick=${signOutAndRedirect}>${t('operations.banner.supportExit')}</button>
        </div>`
      : null}
    ${text
      ? html`<div class="operations-banner" data-variant=${state?.accessMode === 'READ_ONLY' ? 'danger' : 'warning'} role="status">
          <${Icon} name=${state?.accessMode === 'READ_ONLY' ? 'IconLock' : 'IconAlertTriangle'} size=${16} />
          <span class="operations-banner-text">${text}</span>
          <${Link} href="/settings/billing" className="operations-banner-action">${t('operations.banner.action')}<//>
        </div>`
      : null}
  </div>`;
}
